export const confirmCallValues = [
    {
        registerStateLabel: "check_1",
        label: "I confirm that I have complied with the terms and conditions of the Expert Agreement and have not disclosed any confidential information."
    },
    {
        registerStateLabel: "check_2",
        label: "I confirm that I will not disclose or attempt to benefit from any information revealed to me during the engagement"
    }
]